import React from 'react';
import { CheckCircle, X } from 'phosphor-react';

const itemBase =
  'flex items-center gap-3 py-3.5 px-4 rounded-lg border-2 transition-all duration-200 cursor-default';

const itemVariants = {
  'correct-selected':
    'bg-emerald-500/10 border-emerald-500 text-emerald-800 dark:text-emerald-400',
  'incorrect-selected':
    'bg-red-500/10 border-red-500 text-red-800 dark:text-red-400',
  'correct-not-selected':
    'bg-emerald-500/5 border-emerald-500/30 text-emerald-800 opacity-80 dark:text-emerald-400',
  neutral: 'bg-[var(--bg-tertiary)] border-[var(--border-color)] text-[var(--text-secondary)]',
};

const labelVariants = {
  correct: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
  incorrect: 'bg-red-500/15 text-red-600 dark:text-red-400',
};

/**
 * Component to render a single option item for SingleCorrectAnswer/Passage review
 * Shows user selection with correct/incorrect styling
 */
export function OptionItem({ option, isUserSelected, isCorrectOption, showOnlyUserAnswer = true }) {
  let variant = 'neutral';
  let IconComponent = null;

  if (isUserSelected) {
    if (isCorrectOption) {
      variant = 'correct-selected';
      IconComponent = <CheckCircle size={20} weight="fill" className="text-emerald-500 shrink-0" />;
    } else {
      variant = 'incorrect-selected';
      IconComponent = <X size={20} weight="fill" className="text-red-500 shrink-0" />;
    }
  }

  if (!isUserSelected && isCorrectOption && !showOnlyUserAnswer) {
    variant = 'correct-not-selected';
  }

  if (showOnlyUserAnswer && !isUserSelected) {
    return (
      <div key={option.id} className={`${itemBase} ${itemVariants[variant]}`}>
        <div className="flex-1 flex items-center">
          <span className="text-[15px] leading-relaxed">{option.text}</span>
        </div>
      </div>
    );
  }

  return (
    <div key={option.id} className={`${itemBase} ${itemVariants[variant]}`}>
      <div className="flex-1 flex items-center gap-3">
        {IconComponent}
        {!isUserSelected && isCorrectOption && !showOnlyUserAnswer && (
          <CheckCircle size={20} weight="fill" className="text-emerald-500 shrink-0" />
        )}
        <span className="text-[15px] leading-relaxed">{option.text}</span>
      </div>
      {isUserSelected && (
        <div className="flex items-center gap-2 shrink-0">
          <span
            className={`px-2.5 py-1 rounded text-xs font-medium ${
              isCorrectOption ? labelVariants.correct : labelVariants.incorrect
            }`}
          >
            Your Answer
          </span>
          {isCorrectOption ? (
            <CheckCircle size={16} weight="fill" className="text-emerald-500" />
          ) : (
            <X size={16} weight="fill" className="text-red-500" />
          )}
        </div>
      )}
      {!isUserSelected && isCorrectOption && !showOnlyUserAnswer && (
        <div className="flex items-center gap-2 shrink-0">
          <span className={`px-2.5 py-1 rounded text-xs font-medium ${labelVariants.correct}`}>
            Correct Answer
          </span>
          <CheckCircle size={16} weight="fill" className="text-emerald-500" />
        </div>
      )}
    </div>
  );
}
